module.exports = __webpack_public_path__ + "static/media/GlobalStudies.f86db7fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/GlobalStudies.png
// module id = 1690
// module chunks = 0